var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M13.4917 1.66602H6.51667C3.48334 1.66602 1.67501 3.47435 1.67501 6.50768V13.4827C1.67501 16.516 3.48334 18.3243 6.51667 18.3243H13.4917C16.525 18.3243 18.3333 16.516 18.3333 13.4827V6.50768C18.3333 3.47435 16.525 1.66602 13.4917 1.66602Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M7.35 13.3508C7.19167 13.3508 7.03334 13.2924 6.90834 13.1674C6.66667 12.9258 6.66667 12.5258 6.90834 12.2841L12.3667 6.82578C12.6083 6.58411 13.0083 6.58411 13.25 6.82578C13.4917 7.06745 13.4917 7.46745 13.25 7.70911L7.79167 13.1674C7.66667 13.2924 7.50834 13.3508 7.35 13.3508Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M7.69168 6.38281C7.01668 6.38281 6.45834 6.93282 6.45834 7.61615C6.45834 8.29115 7.00834 8.84947 7.69168 8.84947C8.36668 8.84947 8.92499 8.29949 8.92499 7.61615C8.91666 6.93282 8.36668 6.38281 7.69168 6.38281Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M13.1417 11.1582C12.4667 11.1582 11.9083 11.7082 11.9083 12.3915C11.9083 13.0665 12.4583 13.6249 13.1417 13.6249C13.8167 13.6249 14.375 13.0749 14.375 12.3915C14.375 11.7082 13.825 11.1582 13.1417 11.1582Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageSquare);
export default __webpack_public_path__ + "static/media/percentage-square.bec387fe576b5f8c61dd48b328b4efcd.svg";
export { ForwardRef as ReactComponent };